module.exports = __webpack_public_path__ + "static/media/rs.60c172c7.png";